import { render, staticRenderFns } from "./DailyVoyageReportSafetyObservationTable.vue?vue&type=template&id=b6603114&"
import script from "./DailyVoyageReportSafetyObservationTable.vue?vue&type=script&lang=js&"
export * from "./DailyVoyageReportSafetyObservationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports